import _ from 'lodash';
import triggerEnsightenEventUtil from '../../../core/triggerEnsightenEvent';
import { TRIGGER_ENSIGHTEN_EVENT } from './EnsightenConstants';
import { BUSINESS_CASE_VARIATION } from '../../../US/USConstants.js';

export const triggerEnsightenEvent = eventName => (dispatch, getState) => {
    const state = getState();
    const flow = _.get(state, 'serverData.flow');
    const businessCaseVariation = _.get(
        state,
        'serverData.businessCaseVariation'
    );
    const isSecondButton = businessCaseVariation ===
        BUSINESS_CASE_VARIATION.HERMES.SECOND_BUTTON;
    // this actually fires the ensighten event using their Bootstrapper api
    const ensightenEvent = triggerEnsightenEventUtil(
        eventName,
        flow,
        isSecondButton
    );
    // this keeps a small log of ensighten events in our store for debugging
    return dispatch({
        type: TRIGGER_ENSIGHTEN_EVENT,
        payload: {
            eventName,
            flow,
            isSecondButton,
            businessCaseVariation,
            ensightenEvent,
            timestamp: Date.now()
        }
    });
};
